

















import { MeasureTypeEnum, RepeatFrequencyEnum } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class MeasureTypeSelect extends Vue {

    get items() {
        return [
            { id: MeasureTypeEnum.Corrective, name: this.$i18n.t("workTask.findingItem.corrective") },
            { id: MeasureTypeEnum.Preventive, name: this.$i18n.t("workTask.findingItem.preventive") }
        ];
    }

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) white!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) clearable!: boolean;
    @Prop({ default: 0 }) maxWidth!: number;

    @Watch("innerValue")
    innerValueChanged (v: string) {
        if (v != null && !this.items.find((x: any) => { return x.id == v; })) {
            this.$emit("input", null);
        }
    }

}
